import BiBaseDataItem from '../common/bi-base-item';

export const PHASE_END_EVID = 13;

/**
 * Represents the "load phase" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13
 *
 * It should be used to monitor custom application load phases.
 */
export default class BiLoadPhaseDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(PHASE_END_EVID, sessionId);
  }
}
